import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import { hasPermission, hasAtLeastOnePermission, createHistory } from '../../sc-utilities';
import ProductTypeList from './ProductTypeList';
import { FindInPage } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});

const ProductType = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productTypeID: null, redirectPath: '' });

    let visible = columns && columns['ProductType'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'ProductTypeID',
            hidden: visible ? visible['ProductTypeID'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {hasPermission(permissions, 'product_type_load') ?
                    <Tooltip key={`Edit-${rowData.ProductTypeID}`} title={translations["product_type_details"] || "Product type details"}>
                        <IconButton
                            id={`edit_product_type_${rowData.ProductTypeID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/product-type/edit?productTypeID=${rowData.ProductTypeID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                    : null
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["key"] || 'Key', field: 'Key',
            hidden: visible ? visible['Key'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Key ? rowData.Key : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            lookup: { '0': translations['no'] || 'No', '1': translations['yes'] || 'Yes' },
            defaultFilter: ['0'],
            filtering: true,
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, [
        "product_type_load"
    ])) {
        tableColumns.shift();
    }

    const redirectHandler = (path, productTypeID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, productTypeID: productTypeID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'product_type_list') ?
                <ProductTypeList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        fetching: state.admin.productType.fetching
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ProductType));


/**
 * Translations:
    name
    key
 *
 */